import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ValidationTestPanel = ({ catalogData }) => {
  const [testResults, setTestResults] = useState(null);
  const [isRunning, setIsRunning] = useState(false);

  const runValidationTests = () => {
    setIsRunning(true);
    
    setTimeout(() => {
      const results = {
        timestamp: new Date()?.toISOString(),
        totalTests: 8,
        passed: 7,
        failed: 1,
        warnings: 2,
        tests: [
          {
            name: 'Cohérence de la hiérarchie',
            status: 'passed',
            message: 'Toutes les relations parent-enfant sont valides',
            icon: 'CheckCircle',
            color: 'text-success'
          },
          {
            name: 'Validation des prix',
            status: 'passed',
            message: '156 services avec tarification correcte',
            icon: 'CheckCircle',
            color: 'text-success'
          },
          {
            name: 'Compétences requises',
            status: 'warning',
            message: '12 services sans compétences définies',
            icon: 'AlertTriangle',
            color: 'text-warning'
          },
          {
            name: 'Durées estimées',
            status: 'passed',
            message: 'Toutes les durées sont dans les limites acceptables',
            icon: 'CheckCircle',
            color: 'text-success'
          },
          {
            name: 'Descriptions manquantes',
            status: 'failed',
            message: '8 services sans description détaillée',
            icon: 'XCircle',
            color: 'text-error'
          },
          {
            name: 'Configuration TVA',
            status: 'passed',
            message: 'Taux de TVA correctement appliqués',
            icon: 'CheckCircle',
            color: 'text-success'
          },
          {
            name: 'Garanties',
            status: 'warning',
            message: '5 services avec garantie &lt; 6 mois',
            icon: 'AlertTriangle',
            color: 'text-warning'
          },
          {
            name: 'Disponibilité géographique',
            status: 'passed',
            message: 'Zones de service correctement configurées',
            icon: 'CheckCircle',
            color: 'text-success'
          }
        ]
      };

      setTestResults(results);
      setIsRunning(false);
    }, 2000);
  };

  const getStatusBadge = (status) => {
    const badges = {
      passed: { bg: 'bg-success/10', text: 'text-success', label: 'Réussi' },
      failed: { bg: 'bg-error/10', text: 'text-error', label: 'Échoué' },
      warning: { bg: 'bg-warning/10', text: 'text-warning', label: 'Attention' }
    };
    const badge = badges?.[status] || badges?.passed;
    return (
      <span className={`text-xs px-2 py-1 rounded-full ${badge?.bg} ${badge?.text} font-medium`}>
        {badge?.label}
      </span>
    );
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="TestTube" size={20} className="text-success" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground">
              Tests de validation
            </h3>
            <p className="text-sm text-muted-foreground">
              Vérification de la cohérence du catalogue
            </p>
          </div>
        </div>
        <Button
          onClick={runValidationTests}
          loading={isRunning}
          iconName="Play"
          size="sm"
        >
          {isRunning ? 'Test en cours...' : 'Lancer les tests'}
        </Button>
      </div>
      {testResults && (
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-4 p-4 bg-muted rounded-lg">
            <div className="text-center">
              <div className="text-2xl font-bold text-success">{testResults?.passed}</div>
              <div className="text-xs text-muted-foreground">Réussis</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-error">{testResults?.failed}</div>
              <div className="text-xs text-muted-foreground">Échoués</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-warning">{testResults?.warnings}</div>
              <div className="text-xs text-muted-foreground">Avertissements</div>
            </div>
          </div>

          <div className="space-y-2">
            {testResults?.tests?.map((test, index) => (
              <div
                key={index}
                className="flex items-start gap-3 p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors"
              >
                <Icon name={test?.icon} size={20} className={test?.color} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <span className="text-sm font-medium text-foreground">
                      {test?.name}
                    </span>
                    {getStatusBadge(test?.status)}
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {test?.message}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-between pt-4 border-t border-border">
            <span className="text-xs text-muted-foreground">
              Dernière exécution: {new Date(testResults.timestamp)?.toLocaleString('fr-FR')}
            </span>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
            >
              Exporter le rapport
            </Button>
          </div>
        </div>
      )}
      {!testResults && (
        <div className="text-center py-8">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
            <Icon name="TestTube" size={32} className="text-muted-foreground" />
          </div>
          <p className="text-sm text-muted-foreground">
            Aucun test exécuté récemment
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Cliquez sur "Lancer les tests" pour valider le catalogue
          </p>
        </div>
      )}
    </div>
  );
};

export default ValidationTestPanel;